module.exports = __webpack_public_path__ + "img/comment.6bdba640.png";